export const states = [
  {
    text: 'Alabama',
    href: '/residential/al/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Alaska',
    href: '/residential/ak/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Arizona',
    href: '/residential/az/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Arkansas',
    href: '/residential/ar/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'California',
    href: '/residential/ca/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Colorado',
    href: '/residential/co/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Connecticut',
    href: '/residential/ct/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Delaware',
    href: '/residential/de/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'District of Columbia',
    href: '/residential/dc/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Florida',
    href: '/residential/fl/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Georgia',
    href: '/residential/ga/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Hawaii',
    href: '/residential/hi/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Idaho',
    href: '/residential/id/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Illinois',
    href: '/residential/il/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Indiana',
    href: '/residential/in/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Iowa',
    href: '/residential/ia/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Kansas',
    href: '/residential/ks/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Kentucky',
    href: '/residential/ky/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Louisiana',
    href: '/residential/la/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Maine',
    href: '/residential/me/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Maryland',
    href: '/residential/md/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Massachusetts',
    href: '/residential/ma/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Michigan',
    href: '/residential/mi/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Minnesota',
    href: '/residential/mn/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Mississippi',
    href: '/residential/ms/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Missouri',
    href: '/residential/mo/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Montana',
    href: '/residential/mt/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Nebraska',
    href: '/residential/ne/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Nevada',
    href: '/residential/nv/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'New Hampshire',
    href: '/residential/nh/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'New Jersey',
    href: '/residential/nj/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'New Mexico',
    href: '/residential/nm/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'New York',
    href: '/residential/ny/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'North Carolina',
    href: '/residential/nc/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'North Dakota',
    href: '/residential/nd/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Ohio',
    href: '/residential/oh/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Oklahoma',
    href: '/residential/ok/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Oregon',
    href: '/residential/or/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Pennsylvania',
    href: '/residential/pa/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Rhode Island',
    href: '/residential/ri/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'South Carolina',
    href: '/residential/sc/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'South Dakota',
    href: '/residential/sd/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Tennessee',
    href: '/residential/tn/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Texas',
    href: '/residential/tx/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Utah',
    href: '/residential/ut/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Vermont',
    href: '/residential/vt/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Virginia',
    href: '/residential/va/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Washington',
    href: '/residential/wa/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'West Virginia',
    href: '/residential/wv/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Wisconsin',
    href: '/residential/wi/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Wyoming',
    href: '/residential/wy/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
  {
    text: 'Puerto Rico',
    href: '/residential/pr/active_lt/resi_sort_v2_st/y_nbs/foreclosures_at',
  },
]

export const counties = [
  { text: 'Maricopa County, AZ', href: '/residential/az/maricopa-county' },
  {
    text: 'Philadelphia County, PA',
    href: '/residential/pa/philadelphia-county',
  },
  {
    text: 'Los Angeles County, CA',
    href: '/residential/ca/los-angeles-county',
  },
  { text: 'Cook County, IL', href: '/residential/il/cook-county' },
  { text: 'Wayne County, MI', href: '/residential/mi/wayne-county' },
  { text: 'Delaware County, PA', href: '/residential/pa/delaware-county' },
  { text: 'Pima County, AZ', href: '/residential/az/pima-county' },
  { text: 'Monroe County, PA', href: '/residential/pa/monroe-county' },
  { text: 'Riverside County, CA', href: '/residential/ca/riverside-county' },
  { text: 'Allegheny County, PA', href: '/residential/pa/allegheny-county' },
  { text: 'Broward County, FL', href: '/residential/fl/broward-county' },
  { text: 'Miami-Dade County, FL', href: '/residential/fl/miami+dade-county' },
  {
    text: 'San Bernardino County, CA',
    href: '/residential/ca/san-bernardino-county',
  },
  { text: 'Union County, NJ', href: '/residential/nj/union-county' },
  { text: 'Palm Beach County, FL', href: '/residential/fl/palm-beach-county' },
  { text: 'Middlesex County, NJ', href: '/residential/nj/middlesex-county' },
  { text: 'Duval County, FL', href: '/residential/fl/duval-county' },
  { text: 'Montgomery County, PA', href: '/residential/pa/montgomery-county' },
  { text: 'Harris County, TX', href: '/residential/tx/harris-county' },
  { text: 'Luzerne County, PA', href: '/residential/pa/luzerne-county' },
  {
    text: 'Hillsborough County, FL',
    href: '/residential/fl/hillsborough-county',
  },
  { text: 'Bucks County, PA', href: '/residential/pa/bucks-county' },
  { text: 'York County, PA', href: '/residential/pa/york-county' },
  { text: 'Pinal County, AZ', href: '/residential/az/pinal-county' },
  { text: 'Fairfield County, CT', href: '/residential/ct/fairfield-county' },
]

export const cities = [
  { text: 'Philadelphia, PA', href: '/residential/pa/philadelphia_ct' },
  { text: 'Phoenix, AZ', href: '/residential/az/phoenix_ct' },
  { text: 'Tucson, AZ', href: '/residential/az/tucson_ct' },
  { text: 'Jacksonville, FL', href: '/residential/fl/jacksonville_ct' },
  { text: 'Chicago, IL', href: '/residential/il/chicago_ct' },
  { text: 'Miami, FL', href: '/residential/fl/miami_ct' },
  { text: 'Detroit, MI', href: '/residential/mi/detroit_ct' },
  { text: 'Pittsburgh, PA', href: '/residential/pa/pittsburgh_ct' },
  { text: 'Memphis, TN', href: '/residential/tn/memphis_ct' },
  { text: 'Colorado Springs, CO', href: '/residential/co/colorado-springs_ct' },
  { text: 'Mesa, AZ', href: '/residential/az/mesa_ct' },
  { text: 'Los Angeles, CA', href: '/residential/ca/los-angeles_ct' },
  { text: 'Orlando, FL', href: '/residential/fl/orlando_ct' },
  { text: 'Aurora, CO', href: '/residential/co/aurora_ct' },
  { text: 'Anchorage, AK', href: '/residential/ak/anchorage_ct' },
  { text: 'Houston, TX', href: '/residential/tx/houston_ct' },
  { text: 'Tampa, FL', href: '/residential/fl/tampa_ct' },
  { text: 'East Stroudsburg, PA', href: '/residential/pa/east-stroudsburg_ct' },
  { text: 'Indianapolis, IN', href: '/residential/in/indianapolis_ct' },
  { text: 'Sacramento, CA', href: '/residential/ca/sacramento_ct' },
  { text: 'Glendale, AZ', href: '/residential/az/glendale_ct' },
  { text: 'Vineland, NJ', href: '/residential/nj/vineland_ct' },
  { text: 'Bakersfield, CA', href: '/residential/ca/bakersfield_ct' },
  { text: 'Albuquerque, NM', href: '/residential/nm/albuquerque_ct' },
  { text: 'Allentown, PA', href: '/residential/pa/allentown_ct' },
]
